/**
 * Who signed in last in this tab. Sign-in remembers the page a signed-out visitor asked
 * for; that page belongs to whoever was on it, so after a sign-out the next person (a
 * shared workstation) lands on their own home, not the last person's page.
 */
const KEY = 'aithora.console.lastUser';

export function rememberSignedInUser(userId: string): void {
  try { window.sessionStorage.setItem(KEY, userId); } catch { /* storage blocked: nobody is sent back */ }
}

export function lastSignedInUser(): string | null {
  try { return window.sessionStorage.getItem(KEY); } catch { return null; }
}

/** The remembered page, only when it was this person's. */
export function fromFor(userId: string, state: { from?: string; fromUser?: string | null } | null): string | undefined {
  return state?.from && state.fromUser && state.fromUser === userId ? state.from : undefined;
}
